module.exports = __webpack_public_path__ + "img/autoshow-slide-01.25d66305.png";